import { render, staticRenderFns } from "./ConditionDetails.vue?vue&type=template&id=2067bb71&"
import script from "./ConditionDetails.vue?vue&type=script&lang=js&"
export * from "./ConditionDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConditionDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports